export const pos = {
  seo: {
    title: 'Kassasysteem voor restaurants | Bistroo',
    description: 'Bistroo quick-service Kassa: een modern en razend snel kassasysteem voor restaurants met pin, cloud-printer en directe koppeling aan je online bestellingen.',
  },
  hero: {
    title: {
      pt1: 'Een',
      pt2: 'kassa',
      pt3: 'die razendsnel afrekent',
    },
    description:
      'De Bistroo POS is ontworpen voor quick-service restaurants die snelheid en overzicht nodig hebben. Bestellen, verwerken en afrekenen. Alles vanuit één intuïtief systeem.',
  },
  paragraphs: {
    paragraph_1: {
      title: 'Bestellen en afrekenen ging nog nooit zo makkelijk',
      text: 'De Bistroo POS verwerkt bestellingen razendsnel. De overzichtelijke interface is gebouwd voor piekperiodes: snelle optieselectie, directe bevestiging en afrekening in één vloeiende flow. Je wachtrijen blijven kort, je gasten tevreden.',
      cta: 'Verken de Bistroo pakketten',
    },
    paragraph_2: {
      title: 'Toegankelijk zonder verplichtingen',
      text: 'Gewoon aansluiten en starten, geen complexe installaties of ingewikkelde setup zoals bij traditionele kassasystemen. Vanaf slechts €15 per maand heb je toegang tot een modern kassasysteem ontworpen voor quick-service restaurants. Geen langlopende contracten, geen verborgen kosten.',
      cta: '',
    },
    paragraph_3: {
      title: 'Keuken- en klantenbonnen automatisch afgedrukt',
      text: 'Elke bestelling print automatisch de juiste bon naar de keuken en de klant. Stel exact in wat er op elke bon verschijnt. Door de naadloze integratie met je keukenprinter loopt je werkstroom altijd soepel, ook in de drukste periodes.',
      cta: 'Verken de Bistroo pakketten',
    },
    paragraph_4: {
      title: 'Volledig beheer via de Bistroo Manager',
      text: 'Beheer je menu, openingstijden, medewerkers en rapportages vanuit de Bistroo Manager. Bekijk je dagomzet, sluit je shift af met een Z-rapport en houd alles bij zonder extra software. Eén systeem voor je volledige operatie.',
      cta: '',
    },
  },
  key_features: {
    cards: {
      card_1: {
        title: 'Snelle orderinvoer.',
        text: 'Voeg bestellingen razendsnel in met duidelijke opties en varianten. Gemaakt voor het tempo van een quick-service restaurant.',
        button: '',
        img_alt: '',
      },
      card_2: {
        title: 'Meerdere betaalmethoden.',
        text: 'Accepteer PIN, contactloos en split-payments. Flexibel afrekenen voor elke situatie.',
        button: '',
        img_alt: '',
      },
      card_3: {
        title: 'Keuken- en klantenbonnen.',
        text: 'Automatische bonafdruk bij elke bestelling, voor zowel de keuken als de klant.',
        button: '',
        img_alt: '',
      },
      card_4: {
        title: 'Shift- en dagafsluiting.',
        text: 'Sluit eenvoudig je dienst of dag af met een volledig Z-rapport. Altijd inzicht in je prestaties.',
        button: '',
        img_alt: '',
      },
      card_5: {
        title: 'Plug-and-play.',
        text: 'Binnen enkele minuten operationeel. Geen technische kennis vereist — gewoon aanzetten en beginnen.',
        button: '',
        img_alt: '',
      },
    },
  },
  testimonial: {
    text: '"Met de Bistroo POS gaan onze bestellingen veel sneller. In de lunchpiek verwerken we nu twee keer zoveel gasten als voorheen — zonder stress."',
    cta: 'Lees het volledige verhaal',
    name: 'Sander de Vries',
    job_title: 'Eigenaar Quick Bites',
  },
  faq: {
    title_pt1: 'Alles over het',
    title_pt2: 'Bistroo kassasysteem',
    items: [
      { q: 'Wat is het Bistroo POS-systeem?', a: 'De Bistroo POS is een modern kassasysteem speciaal ontworpen voor quick-service restaurants. Via een overzichtelijk touchscreen-interface verwerk je bestellingen razendsnel, accepteer je meerdere betaalmethoden en druk je automatisch bonnen af.' },
      { q: 'Hoe snel kan ik beginnen met de Bistroo POS?', a: 'De Bistroo POS is binnen enkele minuten operationeel. Geen ingewikkelde installatie, geen technische kennis vereist. Aanzetten en beginnen.' },
      { q: 'Welke betaalmethoden accepteert de Bistroo POS?', a: 'De POS accepteert pin (contactloos en chip), Apple Pay en Google Pay. Split payments zijn ook mogelijk, zodat een groep gasten hun rekening gemakkelijk kan splitsen.' },
      { q: 'Worden bestellingen automatisch afgedrukt?', a: 'Ja. Elke bestelling print automatisch de juiste bon naar de keuken en de klant. Je stelt zelf in wat er op elke bon verschijnt en welke printer welke bon ontvangt.' },
      { q: 'Wat is een Z-rapport en hoe gebruik ik het?', a: 'Een Z-rapport is een dagelijkse afsluiting van de kassa waarop alle omzet en transacties van de dienst staan. Via de Bistroo POS genereer je het Z-rapport met één druk op de knop aan het einde van elke shift.' },
      { q: 'Kan ik de POS koppelen aan mijn Bistroo webshop?', a: 'Ja. De Bistroo POS is volledig geïntegreerd met de webshop, de bestelzuil en de QR-tafelbestelling. Alle bestellingen uit alle kanalen komen samen in één overzichtelijk systeem.' },
      { q: 'Welke hardware heb ik nodig voor de Bistroo POS?', a: 'Je hebt een tablet of touchscreen-apparaat nodig plus een bondprinter. Bistroo levert ook een complete hardwaresetup. Neem contact op voor een advies op maat.' },
      { q: 'Hoe pas ik mijn menu aan via de POS?', a: 'Menuaanpassingen doe je via de Bistroo Manager-app, op elk apparaat. Wijzigingen zijn direct zichtbaar op de POS, de webshop en eventuele kiosken.' },
      { q: 'Wat kost de Bistroo POS?', a: 'De Bistroo POS is beschikbaar vanaf €15 per maand. Geen langlopende contracten en geen verborgen kosten. Je betaalt alleen voor wat je gebruikt.' },
      { q: 'Kan ik met de Bistroo POS ook meerdere medewerkers beheren?', a: 'Ja. Je maakt aparte medewerkersinloggen aan zodat je altijd kunt zien wie welke bestelling heeft ingevoerd. Handig voor shift-rapportages en personeelsbeheer.' },
    ],
  },
}
